export interface EnvironmentConfig {
  apiUrl: string;
  clientId: string;
  authority: string;
  environment: "sandbox" | "dev" | "uat" | "prod";
}

const AZURE_AUTHORITY =
  "https://login.microsoftonline.com/4b1c6b54-4031-481e-b9c8-9000b4e3b2c2";

const configs: Record<string, EnvironmentConfig> = {
  sandbox: {
    apiUrl: "https://localhost:8443/jarvis/v1",
    clientId: "9d24bed3-51e6-435c-ab35-90f73808a46c",
    authority: AZURE_AUTHORITY,
    environment: "sandbox",
  },
  dev: {
    apiUrl: "https://c.ai.dev.cambridgeassociates.cloud/jarvis/v1",
    clientId: "9d24bed3-51e6-435c-ab35-90f73808a46c",
    authority: AZURE_AUTHORITY,
    environment: "dev",
  },
  uat: {
    apiUrl: "https://c.ai.uat.cambridgeassociates.cloud/jarvis/v1",
    clientId: "946fbbbb-9ae4-47a4-8903-660575d09ce5",
    authority: AZURE_AUTHORITY,
    environment: "uat",
  },
  prod: {
    apiUrl: "https://c.ai.cambridgeassociates.cloud/jarvis/v1",
    clientId: "ab39a089-9f93-4244-9af1-f9392ad116ba",
    authority: AZURE_AUTHORITY,
    environment: "prod",
  },
};

function detectEnvironment(): string {
  if (typeof window === "undefined") return "prod";
  const hostname = window.location.hostname;
  if (hostname.includes("localhost")) return "sandbox";
  if (hostname.includes("dev")) return "dev";
  if (hostname.includes("uat")) return "uat";
  return "prod";
}

export function getConfig(): EnvironmentConfig {
  return configs[detectEnvironment()];
}

export const envConfig = getConfig();
